<template>
  <van-popover 
    v-model="showPopover" 
    trigger="click" 
    @select="handle" 
    :actions="list" 
    style="cursor: pointer;"
  >
    <template #reference>
      <van-button 
        class="van-button van-button--primary van-button--normal van-button--plain" 
        type="button" 
        style="color: rgb(255, 255, 255); border-color: rgb(255, 255, 255); font-size: 14px; height: 26px; padding: 0px 10px; border-radius: 4px; background: none;"
      >
        {{ currentLanguageText }}
      </van-button>
    </template>
  </van-popover>
</template>

<script>
export default {
  name: 'change-language',
  data() {
    return {
      showPopover: false,
      list: [
        // { key: 'zh-CN', text: '中文' }, // 中文
        // { key: 'vi', text: 'Tiếng Việt' }, // 越南语
        // { key: 'hi', text: 'हिन्दी' }, // 印地语
        // { key: 'th', text: 'ไทย' }, // 泰语
        // { key: 'ru', text: 'Русский' }, // 俄语
        // { key: 'ko', text: '한국어' }, // 韩语
        { key: 'en', text: 'English' }, // 英语
        // { key: 'jp', text: '日本語' }, // 日语
        { key: 'tu', text: 'Indonesia' }, // 土耳其语
      ],
    }
  },
  computed: {
    currentLanguageText() {
      const langMap = {
        // 'zh-CN': '中文',
        // 'vi': 'Tiếng Việt',
        // 'hi': 'हिन्दी', 
        // 'th': 'ไทย',
        // 'ru': 'Русский',
        // 'ko': '한국어',
        'en': 'English',
        // 'jp': '日本語',
        'tu': 'Indonesia'
      }
      return langMap[this.$i18n.locale] || 'Language'
    }
  },
  methods: {
    handle(value) {
      console.log('切换语言到:', value.key)
      
      this.$i18n.locale = value.key
      localStorage.setItem('change-language', value.key)
      
      // 刷新页面确保所有组件重新渲染
      setTimeout(() => {
        location.reload()
      }, 100)
    },
  },
  mounted() {
    console.log('当前语言:', this.$i18n.locale)
    console.log('可用语言包:', Object.keys(this.$i18n.messages))
    
    // 从 localStorage 恢复语言设置
    const savedLang = localStorage.getItem('change-language')
    if (savedLang) {
      this.$i18n.locale = savedLang
    }
  }
}
</script>
